
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDuctThreeway as ObiDuctThreewayElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-duct-threeway.js';
 
 
 

 
 export const ObiDuctThreeway = createComponent({
   react: React,
   tagName: 'obi-duct-threeway',
   elementClass: ObiDuctThreewayElement,
   events: {
     
   }
  });
 
 